import {} from 'googlemaps'
import { Position } from '@/components/Map/types'

export const calculatePosition = (position: Record<string, any>): Position => ({
  lat: position?.coords?.latitude || 180,
  lng: position?.coords?.longitude || 180
})

export const getPos = (instance: any, google: any, cb: Function) => (p: any): Promise<any> => {
  return instance.$nextTick(() => instance.$refs.MapRef.$mapPromise
    .then(cb(calculatePosition(p), instance, google)))
}

export const createCurrentPositionMarker = (p: Position, google: any, map: google.maps.Map) => {
  const marker = {
    position: p,
    icon: {
      scaledSize: new google.maps.Size(25, 25),
      url: require('@/assets/markers/blue-dot.png')
    },
    map,
    title: ''
  }

  return new google.maps.Marker(marker)
}

export const setMap = (p: Position, instance: any, google: any) => (map: google.maps.Map): void => {
  const marker = createCurrentPositionMarker(p, google, map)

  instance.currentPositionMarker.forEach((m: any): void => m.setMap(null))
  instance.currentPositionMarker = [marker]

  map.setZoom(18)
  map.setCenter(p)
}
